var _circle, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgContactinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#F1F1F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 20.191a.939.939 0 01-.664-.274l-7.264-7.264a.375.375 0 01-.09-.384c.08-.246.312-.269.518-.269h15c.205 0 .435.023.517.27a.375.375 0 01-.09.383l-7.265 7.264a.94.94 0 01-.663.274z",
    fill: "#0F0449"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.837 13.366A.137.137 0 0127 13.5v9a1.5 1.5 0 01-1.5 1.5h-15A1.5 1.5 0 019 22.5v-9a.136.136 0 01.232-.097l7.308 7.31a2.062 2.062 0 002.916 0l7.31-7.31a.136.136 0 01.07-.037z",
    fill: "#0F0449"
  })));
}

export default SvgContactinline;